import { Ref, useState } from 'react'

import { Alert, Stack } from '@vtex/shoreline'
import { t } from 'i18next'

import { FormGroup, InputHidden, Label } from '~/components/unform'
import TagInput from '~/components/unform/TagInput'

import { keywordsStringToCleanArray } from '../unform/TagInput/helpers'

type KeywordListInputProps = {
  onChange?: (data: { value: string[] }) => void
  onChangePendingValues?: (data: { value: string[] }) => void
  validateBeforeCreate?: () => string[]
  placeholder?: string
  label?: string
  helperText?: string
  name: string
  required?: boolean
  errorsRef?: Ref<string[]>
}

const KeywordListInput = ({
  onChange,
  name,
  placeholder,
  helperText,
  required,
  errorsRef,
  label = t('rm:keywords'),
  onChangePendingValues,
  validateBeforeCreate
}: KeywordListInputProps) => {
  const [values, setValues] = useState([])

  const handleCreateKeyword = (value: string[]) => {
    onChange?.({ value })

    setValues(value)
  }

  const handleDeleteKeyword = (index: number) => {
    const handleAction = (keywords: string[]) => {
      const newData = keywords?.filter((_, i) => index !== i)

      onChange?.({ value: newData })

      return newData
    }

    setValues(handleAction)
  }

  const handleInputChange = (value: string) => {
    onChangePendingValues?.({ value: keywordsStringToCleanArray(value) || [] })
  }

  return (
    <FormGroup className="fullWidth">
      <Label
        htmlFor={`keyword-list-input-${name}`}
        isRequired={required}
        text={label}
        helperText={helperText}
      />

      {errorsRef?.current?.map(message => (
        <div key={message} className={'my-2'}>
          <Alert variant="critical">
            <Stack align="start">{message}</Stack>
          </Alert>
        </div>
      ))}

      <TagInput
        name={`keyword-list-input-${name}`}
        placeholder={
          placeholder || t('rm:campaign.formV2.targeting.keywords.placeholder')
        }
        onCreate={handleCreateKeyword}
        onDelete={handleDeleteKeyword}
        onInputChange={handleInputChange}
        validateBeforeCreate={validateBeforeCreate}
        tags={values}
        autoFocus
      />
      <InputHidden value={values.join(';')} name={name} />
    </FormGroup>
  )
}

export default KeywordListInput
